import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { arrowForward, menu } from "ionicons/icons";
import { CategorieLinks } from "../../components/CategorieLinks/CategorieLinks";
import { Link } from "react-router-dom";
import { PackageContent, PackageDelivery } from "./Content";
import { useEffect } from "react";
import { usePictures } from "../Pictures/usePictures";

// Sadržaj seta
const PackageContentPage = () => {
  const { allPictures, getAllPictures } = usePictures();

  useEffect(() => {
    if (allPictures.length === 0) {
      getAllPictures();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuToggle>
                <IonIcon icon={menu} style={{ fontSize: 28 }} />
              </IonMenuToggle>
            </IonButtons>
            <IonTitle>Sadržaj seta</IonTitle>
            <IonButtons slot="end">
              <Link to={{ pathname: "/slike" }}>
                <IonButton color="dark">Motivi</IonButton>
              </Link>
            </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid className="ion-no-padding">
          <IonRow>
            <IonCol size="12" sizeMd="6" offsetMd="3">
              <img src="assets/BPB_logo.png" alt="" className="slide-image" />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" sizeMd="6" offsetMd="3">
              <IonCard
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  aspectRatio: "1 / 1.2",
                  overflow: "hidden",
                  borderRadius: "12px",
                  margin: "20px auto",
                }}
              >
                <iframe
                  src={`https://www.youtube.com/embed/ye1kjhgG5Yg`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                ></iframe>
              </IonCard>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" sizeMd="6" offsetMd="3">
              <IonCard>
                <IonCardContent>
                  <PackageContent />
                  <PackageDelivery />
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <CategorieLinks />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center">
              <Link to={{ pathname: `/ram` }}>
                <IonButton fill="clear" style={{ margin: "10px 0 20px 0" }}>
                  Ram i štafelaj
                  <IonIcon slot="end" icon={arrowForward} />
                </IonButton>
              </Link>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default PackageContentPage;
